import DragObject from './drag-object.js';

class DragObject2DElement extends DragObject {
    constructor(object) {
        super();

        this._object = object;
    }

    _assignCoordinates(coords) {
        let object = this._object;
        let sizeKey = object.getVWSize();
        Object.assign(object[sizeKey], coords);
        if (!Q3.editMode) {
            Object.assign(object.data[sizeKey], coords);
        }
    }

    getPosition() {
        let { x, y } = this._object;
        return { x, y };
    }

    setPosition({ x, y }) {
        this._assignCoordinates({ x, y });
        this._object.redraw();
        if (Q3.editMode && this._object.removeFromQuiz && this._object.removeFromQuiz.get(this._object.clickElement) && this._object.setRemoveElPosition) {
            this._object.setRemoveElPosition( this._object.clickElement);
        }
    }

    getSize() {
        let { width, height } = this._object;
        return { x: width, y: height };
    }

    setSize({ x, y }) {
        this._assignCoordinates({ width: x, height: y });
        this._object.redraw();
    }

    getObject() {
        return this._object;
    }
}

export default DragObject2DElement;
